import { RequestStatus } from 'types/common';
import { Type } from './action-types';
import { stateFactory } from './factories';
import { EddyAction, EddyState } from './types';

const defaultState = stateFactory();

function reducer(
  state: EddyState = defaultState,
  action: EddyAction,
): EddyState {
  switch (action.type) {
    case Type.EDDY_PROJECT_POLL_REQUEST:
      return state
        .set('pollStatus', RequestStatus.REQUEST)
        .set('eddyProject', undefined);

    case Type.EDDY_PROJECT_POLL_SUCCESS: {
      const { eddyProject } = action.payload;

      return state
        .set('pollStatus', RequestStatus.SUCCESS)
        .set('eddyProject', eddyProject);
    }

    case Type.EDDY_PROJECT_POLL_UPDATE: {
      const { eddyProject } = action.payload;

      return state.set('eddyProject', eddyProject);
    }

    case Type.EDDY_PROJECT_POLL_FAILURE:
      return state
        .set('pollStatus', RequestStatus.FAILURE)
        .set('eddyProject', undefined);

    case Type.EDDY_PROJECT_POLL_CANCEL:
      return state.set('pollStatus', undefined);

    case Type.EDDY_PROJECT_CLEAR:
      return state.set('pollStatus', undefined).set('eddyProject', undefined);

    default:
      return state;
  }
}

export default reducer;
